import type { IWheelDefinition } from "./ICaseDefinition/IWheelDefinition";

export interface WheelDefinition extends IWheelDefinition {
  Wheel: string;
  WheelConfiguration: SunlabsWheelConfiguration;
}

/**
 * @graphql2 enum
 */
export enum SunlabsWheelConfiguration {
  Foot_Standard = "Foot_Standard",
  Foot_WithCornerWheel = "Foot_WithCornerWheel",
  Foot_WithTrolleyFunction = "Foot_WithTrolleyFunction",
  Foot_WithPulloutHandle = "Foot_WithPulloutHandle",
  Wheel_WithPulloutHandle = "Wheel_WithPulloutHandle",
  WheelNotch_Standard = "WheelNotch_Standard",
  Wheel_TwoRightBody = "Wheel_TwoRightBody",
  Wheel_WithTrolleyFunction = "Wheel_WithTrolleyFunction",
  WheelboardBraked_TwoBottomBody = "WheelboardBraked_TwoBottomBody",
  WheelboardWheelBraked_TwoBottomBody = "WheelboardWheelBraked_TwoBottomBody",
  WheelboardWheelNonBraked_TwoBottomBody = "WheelboardWheelNonBraked_TwoBottomBody",
  WheelboardWheelNonBraked_FourBottomBody = "WheelboardWheelNonBraked_FourBottomBody",
  WheelboardBraked_OneBottomRackDoubleDoorBody = "WheelboardBraked_OneBottomRackDoubleDoorBody",
  PulloutHandle_Standard = "PulloutHandle_Standard",
  WheelboardNonBraked_OneBottomRackDoubleDoorBody = "WheelboardNonBraked_OneBottomRackDoubleDoorBody",
  Slidebar_Standard = "Slidebar_Standard",
  WheelboardNonBraked_TwoBottomBody = "WheelboardNonBraked_TwoBottomBody",
}
